import { useQuery } from '@tanstack/vue-query';
import { debounce } from 'lodash';
import { ref, Ref, watch } from 'vue';

import personApi from '~/services/person-api/person-api';
import { PersonAPI } from '~/services/person-api/person-api.types';
import objectUtils from '~/utils/objects';

export default function usePartners(params: Ref<PersonAPI.ListPartnersParams>) {
  const queryKey = ref(['partners', objectUtils.objectParamsToString(params.value)]);

  const queryFn = async () => {
    const res = await personApi.partner.list(params.value);
    return res;
  };

  const query = useQuery({
    queryFn,
    queryKey,
    retry: 3,
  });

  const debouncedUpdateQueryKey = debounce((newParams) => {
    queryKey.value = [
      'partners',
      objectUtils.objectParamsToString(newParams),
    ];
  }, 300);

  watch(
    () => params.value,
    (newParams) => {
      debouncedUpdateQueryKey(newParams);
    },
  );

  return query;
}
